import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TextField } from "@mui/material";
import "./index.scss";
import TimeTool from "../../../components/time-tool";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        borderRight: "1px solid #CFD3DD",
        opacity: 1,
        fontSize: 16,
    },
    [`&.${tableCellClasses.body}`]: {
        borderTop: "1.1px solid #CFD3DD",
        borderRight: "1px solid #CFD3DD",
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "td:last-child, th:last-child": {
        borderRight: 0,
    },
}));

const ScheduleTableCard = (props: any) => {

    const { scheduleProps } = props
    const rows = [...scheduleProps];
    const schedule = scheduleProps;

    return (
        <>
            {schedule && (
                <>
                    <TableContainer
                        component={Paper}
                        className="schedule-table-container"
                    >
                        <Table
                            sx={{ minWidth: 700 }}
                            aria-label="customized table"
                            className="schedule-table"
                        >
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell className="schedule-table-header">
                                        TIME
                                    </StyledTableCell>
                                    <StyledTableCell className="schedule-table-header">
                                        SCENE
                                    </StyledTableCell>
                                    <StyledTableCell className="schedule-table-header">
                                        DESCRIPTION
                                    </StyledTableCell>
                                    <StyledTableCell className="schedule-table-header">
                                        CAST
                                    </StyledTableCell>
                                    <StyledTableCell className="schedule-table-header">
                                        LOCATION
                                    </StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {rows.map((row, index) => (
                                    <StyledTableRow
                                        key={`${row.id}`}
                                        hover
                                        className="schedule-table-row"
                                    >
                                        <StyledTableCell
                                            className="schedule-table-column"
                                            component="th"
                                            scope="row"
                                        >
                                            <TimeTool
                                                size="small"
                                                disabled
                                                time={row.time}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell className="schedule-table-column">
                                            <TextField
                                                className="unborder"
                                                disabled
                                                value={row.scene}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell className="schedule-table-column center">
                                            <TextField
                                                className="unborder"
                                                multiline
                                                disabled
                                                maxRows={2}
                                                value={row.description}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell className="schedule-table-column center">
                                            <TextField
                                                className="unborder"
                                                multiline
                                                disabled
                                                maxRows={2}
                                                value={row.cast}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell className="schedule-table-column center">
                                            <TextField
                                                className="unborder"
                                                disabled
                                                value={row.location}
                                            />
                                        </StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            )}
        </>
    );
};

export default ScheduleTableCard;
